import { SidebarContainer, SidebarLogo } from "./styled";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { Navigation } from "./navigation/navigation";
import React, { useEffect, useRef } from "react";
import OutsideClick from "../../hooks/outside-clicked.hook";
import { changeSidebarIsOpen } from "../../redux/slices/sidebar.slice";
import logo from "../../assets/logo.png";
import { onLogoClick } from "../shared/helper-functions";
import { useNavigate } from "react-router-dom";
import { UserGroups } from "../../router/router";

export const Sidebar = React.memo(({ headerRef }: SidebarProps) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const sidebarRef = useRef(null);

    const { items } = useAppSelector(state => state.sidebarReducer);
    const { inOrders, withNavigate, isOpen } = useAppSelector(state => state.sidebarReducer);
    const { matchesPhone } = useAppSelector(state => state.deviceReducer);
    const { currentUser } = useAppSelector(state => state.currentUserReducer);
    const isAdmin = currentUser?.userGroup.userGroupId === UserGroups.ADMIN;
    const isWarehouseWorker =
      currentUser?.userGroup.userGroupId === UserGroups.WAREHOUSE_WORKER;
    const isLocalWarehouseWorker =
      currentUser?.userGroup.userGroupId === UserGroups.LOCAL_WAREHOUSE_WORKER;

    const isOutsideClicked = OutsideClick(sidebarRef, headerRef);

    useEffect(() => {
        if (isOutsideClicked && matchesPhone) {
            dispatch(changeSidebarIsOpen(false));
        }
    }, [isOutsideClicked])

    return (
        <div ref={sidebarRef}>
            {isOpen
                ? <SidebarContainer>
                    {matchesPhone
                        ? <SidebarLogo>
                            <img src={logo}
                                onClick={() => onLogoClick(isAdmin, isWarehouseWorker, isLocalWarehouseWorker, currentUser, dispatch, navigate)}
                                style={{ height: '3rem' }}
                                alt={""} />
                        </SidebarLogo>
                        : ''
                    }

                    <Navigation inOrders={inOrders} withNavigate={withNavigate} items={items} />
                </SidebarContainer>
                : <></>
            }
        </div>
    )
});

interface SidebarProps {
    headerRef: any,
}